var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"pos-header"},[_c('div',{staticClass:"logo"},[_c('i',{staticClass:"el-icon-s-shop"}),_vm._v(" "+_vm._s(_vm.systemInfo.systemSimpleTitle)+" "+_vm._s(_vm.systemInfo.version)+" ")]),_c('div',{staticClass:"status-bar"},[_vm._v(" 操作员: "+_vm._s(_vm.username)+" | "),_c('span',[_vm._v(_vm._s(_vm.currentTime))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }